import {Injectable} from '@angular/core';
import {ActionCreatorAbstract} from '../../../core/classes/action-creator.abstract';
import {Store} from '@ngrx/store';
import {ClearNotification, SetNotification} from '@ispm/dashboard/notification/store/notification.actions';
import {INotificationState} from '@ispm/dashboard/notification/store/notification.reducer';

@Injectable()
export class NotificationStoreHandler extends ActionCreatorAbstract {

  constructor(store: Store<INotificationState>) {
    super(store);
  }

  public setNotification(notification: INotificationState): void {
    if (notification) {
      this.store.dispatch(new SetNotification(notification));
    }
  }

  public clearNotification(): void {
      this.store.dispatch(new ClearNotification());
    }
}
